import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useIntl } from 'react-intl';

import type { GameTypeName } from '../../../../types/Game';
import { GameType } from '../../../../types/Game';
import { getPromoGameName } from '../../../../utils/getPromoGameName';

import {
  TXTCLI_Buy_In,
  TXTCLI_FLASH,
  TXTCLI_HOLDXEM,
  TXTCLI_HoldXem_Six,
  TXTCLI_MAX_HOLDXEM,
  TXTCLI_OMAHA
} from './GameName.messages.json';
import styles from './GameName.scss';

interface GameNameProps {
  gameType: GameTypeName;
  promoRef: string;
  buyIn: string;
}

export const TITLES: {
  [key in GameType]: { name: TranslationTag };
} = {
  Holdem: { name: TXTCLI_HOLDXEM },
  HoldemFlash: { name: TXTCLI_FLASH },
  Omaha: { name: TXTCLI_OMAHA },
  HoldemMax: { name: TXTCLI_MAX_HOLDXEM },
  HoldemSix: { name: TXTCLI_HoldXem_Six }
};

const GameName: React.FC<GameNameProps> = ({ buyIn, gameType, promoRef }) => {
  const { formatMessage } = useIntl();

  const gameName = promoRef
    ? getPromoGameName(gameType, promoRef)
    : formatMessage(TITLES[gameType].name);
  const isHoldemMax = gameType === GameType.HoldemMax;

  return (
    <div className={styles.gameNameContainer}>
      {isHoldemMax && (
        <div className={styles.buyInContainer}>
          <div className={styles.label}>
            <Translation {...TXTCLI_Buy_In} />
          </div>
          <div className={styles.value}>{buyIn}</div>
        </div>
      )}

      <div className={isHoldemMax ? styles.holdemMaxGameName : styles.gameName}>{gameName}</div>
    </div>
  );
};

export default GameName;
